import { ErrorMessage, Field, type FieldProps, useFormikContext } from "formik"
import { Checkbox } from "primereact/checkbox"
import { classNames } from "primereact/utils"
import type { FC } from "react"

import type { OnboardingPersonFormType } from "patient/types"

const TermsAcceptedField: FC = () => {
  const { setFieldValue } = useFormikContext<OnboardingPersonFormType>()

  return (
    <div className="flex flex-col gap-1 min-w-0 mb-2">
      <Field name="termsAccepted">
        {({ field, meta }: FieldProps) => (
          <div className="flex items-start gap-2">
            <Checkbox
              inputId="termsAccepted"
              checked={!!field.value}
              onChange={(e) => setFieldValue("termsAccepted", e.checked ?? false)}
              className={classNames("checkbox-sm checkbox-primary mt-1", {
                "p-invalid": meta.touched && meta.error,
              })}
            />
            <label htmlFor="termsAccepted" className="text-sm text-gray-500 cursor-pointer leading-5 mr-2">
              <span>I have read and agree to the</span>{" "}
              <a
                title="Terms of Service & Privacy Policy"
                href="https://www.chartedhealth.com/privacy-policy"
                rel="noreferrer"
                target="_blank"
                className="text-primary"
                onClick={(e) => e.stopPropagation()}
              >
                Terms of Service and Privacy Policy
              </a>
              .
            </label>
          </div>
        )}
      </Field>
      <ErrorMessage name="termsAccepted" component="small" className="p-error block shrink-0" />
    </div>
  )
}

export { TermsAcceptedField }
